module.exports = __webpack_public_path__ + "static/media/PLAYER4.640bc37c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/PLAYER4.png
// module id = 269
// module chunks = 0